import type { IconData } from '@stacksjs/iconify-core'

export const triangleDown: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 171h232L116 287z\"/>",
  "width": 240,
  "height": 700,
  "viewBox": "0 0 240 700"
}

export default triangleDown
